<div class="table-responsive"
	 [class.block-loader]="(listLoader.isLoading$ | async)">
	<loader-spinner [model]="listLoader"/>
	<table class="table table-hover table-sortable">
		<thead class="thead-light">
		<tr>
			<th class="col-id is-sortable"
				translate="DataList.Columns.ColumnName"
				[ngClass]="getSortClasses(sortCols.COLUMN)"
				(click)="setSort(sortCols.COLUMN)">
			</th>
			<th class="col-error-msg"
				translate="DataList.Columns.ErrorType"
			>
			</th>
			<th class="col-small-amount is-sortable"
				translate="DataList.Columns.ErrorCount"
				[ngClass]="getSortClasses(sortCols.ERROR_COUNT)"
				(click)="setSort(sortCols.ERROR_COUNT)">
			</th>
			<th class="col-small-status"
				translate="DataList.Columns.State"
			>
			</th>
			<th class="col-error-description"
				translate="DataList.Columns.Action"
			>
			</th>
			<th class="col-btn-expand"></th>
		</tr>
		</thead>
		<tbody>
		@for (reportErrorColumn of list.items; track reportErrorColumn.label+reportErrorColumn.errorCode) {
			<tr import-report-errors-list-table-row
				[class.table-collapsible]="hasErrorReportLine(reportErrorColumn)"
				[class.table-active]="reportErrorColumn.isReportErrorLineListOpened"
				[currentImport]="currentImport"
				[reportErrorColumn]="reportErrorColumn"
				(click)="onToggle(reportErrorColumn)">
			</tr>

			@if (reportErrorColumn.isReportErrorLineListOpened) {
				<tr class="table-collapsible-content">
					<td colspan="6">
						<import-report-errors-list-table-lines
							[reportErrorColumn]="reportErrorColumn"
							[columnName]="columnMapping(reportErrorColumn.column)"
							[actions]="actions"
							[selectors]="selectors"
							[currentImport]="currentImport"
						/>
					</td>
				</tr>
			}
		}
		@if (list.items.length === 0 && !listLoader.isLoading) {
			<tr table-row-empty message="Import.Creation.ValidationAndProcessing.ReportSuccess"></tr>
		}
		</tbody>
	</table>
</div>
